import * as Yup from 'yup';

export default Yup.object().shape({
    password: Yup.string().min(5, "Мінімальна кiлькість символів 4").required('Заповніть це поле')
        .max(255, "Максимальна кількість символів досягнута"),
    passwordCopy: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match').required('Заповніть це поле')
        .max(255, "Максимальна кількість символів досягнута")
});